/**
 * Copia texto funcionando também fora de contexto seguro.
 *
 * `navigator.clipboard` só existe em HTTPS ou localhost. Servido por HTTP em
 * qualquer outro host — a máquina pela rede local, um ambiente de teste — ele
 * vem `undefined`, e `navigator.clipboard.writeText(...)` estoura dentro do
 * handler de clique: o botão "Copiar" não copia e ainda assim mostrava
 * "Link copiado!", porque o toast vinha logo depois sem verificar nada.
 *
 * O fallback com `execCommand('copy')` é obsoleto, mas é o único caminho que
 * funciona em contexto inseguro — e é preferível a esconder o botão.
 *
 * Devolve `true` só quando a cópia realmente aconteceu, para que a mensagem de
 * sucesso não minta.
 */
export async function copyToClipboard(text: string): Promise<boolean> {
  if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      // Permissão negada ou contexto inseguro: cai no fallback.
    }
  }

  if (typeof document === 'undefined') {
    return false;
  }

  const area = document.createElement('textarea');
  area.value = text;
  area.setAttribute('readonly', '');
  area.style.position = 'fixed';
  area.style.top = '-9999px';
  area.style.opacity = '0';
  document.body.appendChild(area);
  area.select();

  try {
    return document.execCommand('copy');
  } catch {
    return false;
  } finally {
    document.body.removeChild(area);
  }
}
